import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MatDialog, MatDialogConfig } from '@angular/material';
import { environment } from '../../environments/environment';

import { MatSnackBar } from "@angular/material";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

import { PublicacionService } from '../services/publicacion.service';
import { Publicacion } from '../models/publicacion';
@Component({
  selector: 'app-publicacion-img-extra-editor',
  templateUrl: './publicacion-img-extra-editor.component.html',
  styleUrls: ['./publicacion-img-extra-editor.component.css']
})
export class PublicacionImgExtraEditorComponent implements OnInit {


  model: Publicacion = new Publicacion();
  models: Publicacion[];

  publicacion_id;

  imagen = "./assets/avatar.png";

  upload: boolean = false;
  selectedFile: File = null;

  Url = environment.imgUrl;
  loading: boolean = false;

  constructor(private modelService: PublicacionService, public dialog: MatDialog, private dialogRef: MatDialogRef<PublicacionImgExtraEditorComponent>, @Inject(MAT_DIALOG_DATA) data, private snackBar: MatSnackBar) {
    this.publicacion_id = data.id;

    if (data.id != 0) {
      this.get(data.id);
    }
  }

  ngOnInit() {
  }

  get(id) {
    this.modelService.get(id).subscribe(
      val => {
        this.models = val.imagenes;
      },
      error => {
        console.log(<any>error);
      });

  }


  delete(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '300px';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == true) {
          this.modelService.deleteImg(id).subscribe(
            val => {
              this.get(this.publicacion_id);
              this.snackBar.open('Registro Eliminado', '', {
                duration: 2000,
              });
            });
        }
      }
    );

  }

  onFileChange(event) {

    this.selectedFile = <File>event.target.files[0];
    this.upload = true;

    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imagen = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    // this.model.imagen = 'new';
    this.onUploadFile();
  }

  onUploadFile() {

    const data = new FormData();
    data.append('imagen', this.selectedFile, this.selectedFile.name);

    this.modelService.changeImageExtra(data, this.publicacion_id).subscribe(
      val => {
        this.loading = false;
        this.snackBar.open('Registro Guardado', '', {
          duration: 2000,
        });

        this.imagen = "./assets/avatar.png";
        this.upload = false;
        this.selectedFile = null;
        this.get(this.publicacion_id);
      });
  }

  close() {
    this.dialogRef.close();
  }
}
